import { Fragment, PureComponent, ReactNode, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { AGORA_APP_ID } from '../api/constants';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ringingTune from '../assets/phone_ringing.mp3';
import { motion, useAnimation } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { GO_TO_END_CALL_WITH_ID } from './routes';
import fetchUhiTeleContext from '../api/fetchUhiTeleContext';
import { track } from '../tracking/mixpanel';
import FullScreenLoader from '../components/FullScreenLoader';
import getPaitentJoiningUrlTeleV2 from '../api/getPaitentJoiningUrlTeleV2';

type Props = RouteComponentProps<{ vId: string }>;

type State = {
    fetchState: '' | 'success' | 'error' | 'successTeleV2'; //
    docName: string;
    docDp: string;
    isVideoOn: boolean;
    isAudioOn: boolean;
    isDocJoined: boolean;
    isDocVideoOn: boolean;
    isCallInit: boolean;
    isDocAudioOff: boolean;
    isDocVideoOff: boolean;
    isDocLeft: boolean;
    streamId?: number;
    cameraFacingMode: 'user' | 'environment';
    scriptsLoaded: {
        agoraJs: boolean;
    };
    allowPermissionDialog?: boolean;
    meetingUrlForGuest: string;
};

const PT_VD_ELEMENT_ID = 'pt-vd';
const DOC_VD_ELEMENT_ID = 'me';
const MAX_CALL_TIMEOUT_MS = 45 * 1000;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
let client;

const localTracks = {
    videoTrack: null,
    audioTrack: null,
};

const appid = AGORA_APP_ID;

class VisitVideoCall extends PureComponent<Props, State> {
    state: State = {
        fetchState: '',
        docName: '',
        docDp: '',
        isVideoOn: true,
        isAudioOn: true,
        isDocJoined: false,
        isDocVideoOn: false,
        isCallInit: false,
        isDocAudioOff: false,
        isDocVideoOff: false,
        isDocLeft: false,
        cameraFacingMode: 'user',
        scriptsLoaded: {
            agoraJs: false,
        },
        meetingUrlForGuest: '',
    };
    callRining = new Audio(ringingTune);

    token: string | null = null;
    channel: string | null = null;
    userid: string | null = null;

    callTimeout: NodeJS.Timeout | undefined;

    parent: Window | null = null;

    constructor(props: Props) {
        super(props);

        const agoraSDKJs = document.createElement('script');
        agoraSDKJs.onload = () => {
            setTimeout(() => {
                this.setState({
                    scriptsLoaded: {
                        ...this.state.scriptsLoaded,
                        agoraJs: true,
                    },
                });
            }, 3000);
        };
        agoraSDKJs.src = '/AgoraRTC_N-4.11.0.js';
        document.getElementsByTagName('head')[0].appendChild(agoraSDKJs);

        this.callRining.addEventListener(
            'ended',
            () => {
                this.callRining.play();
            },
            false,
        );
    }

    componentDidMount = (): void => {
        this.fetchDeets();
    };

    alertBeforeRefresh = (event: BeforeUnloadEvent): void => {
        event.preventDefault();
        event.returnValue = '';
    };

    fetchDeets = (): void => {
        getPaitentJoiningUrlTeleV2(this.props.match.params.vId)
            .then((res) => {
                console.log(res, 'res from tele');
                console.log(res.redirect, 'REDIRECT');
                console.log(res.guest_url, 'url');

                if (res.guest_url && !res.redirect) {
                    console.log('1');
                    // in case of eka's-100ms and non-eka-100ms it'll go here since that is iframe embedable
                    this.setState({
                        meetingUrlForGuest: res.guest_url,
                        fetchState: 'successTeleV2',
                    });
                } else if (res.guest_url && res.redirect) {
                    console.log('2');
                    // but incase of meet, zoom etc we need to redirect since these platforms are not iframe friendly
                    // window.location.href = res.guest_url;
                    // window.location.replace(res.guest_url);
                    console.log(window.location.href, 'href');
                    window.parent.location.replace(res.guest_url);
                } else {
                    window.alert('An error occured in setting up the call');
                }
            })
            .catch((e) => {
                console.info(e, 'could not fetch, Tele v2 flow');
                fetchUhiTeleContext(this.props.match.params.vId)
                    .then((res) => {
                        this.setState({
                            fetchState: 'success',
                            docName: res.tele.usr.DoctorName,
                            docDp: res.tele.usr.DoctorURL,
                        });
                        this.channel = res.tele.usr.ChannelName;
                        this.token = res.tele.usr.PToken;
                        this.userid = res.tele.usr.PUserid;
                    })
                    .catch(() => {
                        this.setState({
                            fetchState: 'error',
                        });
                    });
            });
    };

    initCall = async (): Promise<void> => {
        window.addEventListener('beforeunload', this.alertBeforeRefresh);
        this.setState({
            isCallInit: true,
        });

        track('INIT_CALL');

        // window.onbeforeunload = this.onclose;
        // window.onclose = this.onclose;
        // window.onunload = this.onclose;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        client = AgoraRTC.createClient({
            mode: 'rtc',
            codec: 'vp8',
        });

        await this.initLocalStream();

        this.callRining.play();

        if (!this.channel || !this.token || !this.userid) {
            return;
        }

        this.callTimeout = setTimeout(() => {
            location.reload();
        }, MAX_CALL_TIMEOUT_MS);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.joinChannel(this.token, this.channel, this.userid);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        client.on('user-joined', () => {
            this.setState({
                isDocJoined: true,
                isDocLeft: false,
            });
            track('DOC_JOINED');
            this.callTimeout && clearTimeout(this.callTimeout);

            this.callRining.pause();
        });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        client.on('user-left', () => {
            this.setState({
                isDocJoined: false,
                isDocLeft: true,
            });
            track('DOC_LEFT');
            // location.reload();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // client.leave(
            //     () => {
            //         this.setState({
            //             isDocJoined: false,
            //             isDocLeft: true,
            //             isCallInit: false,
            //         });
            //     },
            //     () => {
            //         console.error('Unable to leave channel');
            //         window.close();
            //     },
            // );
        });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        client.on('mute-audio', () => {
            track('MUTE_AUDIO');
            this.setState({
                isDocAudioOff: true,
            });
        });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        client.on('user-published', async (remoteUser, mediaType) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            await client.subscribe(remoteUser, mediaType);
            if (mediaType === 'video') {
                const newLocal = document.getElementById(PT_VD_ELEMENT_ID);

                if (newLocal) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    newLocal.innerHTML = '';
                }

                console.log('subscribe video success');
                remoteUser.videoTrack.play(PT_VD_ELEMENT_ID, { fit: 'contain' });

                // this.setState({
                //     streamId: stream.getId(),
                // });
            }
            if (mediaType === 'audio') {
                console.log('subscribe audio success');
                remoteUser.audioTrack.play();
            }

            this.setState({
                isDocJoined: true,
            });
        });

        client.on(
            'user-info-updated',
            async (
                uid: string,
                msg:
                    | 'mute-audio'
                    | 'mute-video'
                    | 'enable-local-video'
                    | 'unmute-audio'
                    | 'unmute-video'
                    | 'disable-local-video',
            ) => {
                switch (msg) {
                    case 'mute-audio':
                        this.setState({ isDocAudioOff: true });
                        return;
                    case 'unmute-audio':
                        this.setState({ isDocAudioOff: false });
                        return;
                    case 'mute-video':
                        this.setState({ isDocVideoOff: true });
                        return;
                    case 'unmute-video':
                        this.setState({ isDocVideoOff: false });
                        return;
                }
            },
        );
    };

    joinChannel = async (token: string, channel: string, userid: string): Promise<void> => {
        try {
            // Join a channel
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const uid = await client.join(appid, channel, token, userid);
            await this.makeLocalStream();
            track('JOIN_CHANNEL', { channel });
        } catch (e) {
            this.handleError((e as Error).message);
        }
    };

    handleError = (err: string): void => {
        console.log('Error: ', err);
        track('JOIN_CHANNEL', { err: new String(err).toString() });
        // window.close();
    };

    unpublishLocalStream = async (): Promise<void> => {
        const localVideoContainer = document.getElementById(DOC_VD_ELEMENT_ID);
        if (localVideoContainer) {
            localVideoContainer.innerHTML = '';
        }

        if (!localTracks.audioTrack && !localTracks.videoTrack) {
            return;
        }
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            await client.unpublish(
                [localTracks.audioTrack, localTracks.videoTrack].filter(Boolean),
            );
        } catch (e) {
            this.handleError((e as Error).message);
        }
    };

    makeLocalStream = async (): Promise<void> => {
        try {
            // Remove this line if the channel profile is not live broadcast.
            // await client.setClientRole("host");
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            await client.publish([localTracks.audioTrack, localTracks.videoTrack]);
        } catch (e) {
            this.handleError((e as Error).message);
        }
    };

    muteMyself = (): void => {
        if (!localTracks.audioTrack) {
            return;
        }
        if (this.state.isAudioOn) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.audioTrack.setMuted(true);
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.audioTrack.setMuted(false);
        }
        this.setState({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isAudioOn: !this.state.isAudioOn,
        });
    };

    videoOnOff = (): void => {
        if (!localTracks.videoTrack) {
            return;
        }
        if (this.state.isVideoOn) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.videoTrack.setMuted(true);
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.videoTrack.setMuted(false);
        }

        this.setState({
            isVideoOn: !this.state.isVideoOn,
        });
    };

    endCall = async (): Promise<void> => {
        for (const trackName in localTracks) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const track = localTracks[trackName];
            if (track) {
                track.stop();
                track.close();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                localTracks[trackName] = undefined;
            }
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // leave the channel
        await client.leave();
        this.callRining.pause();
        this.setState({ isCallInit: false });
        window.removeEventListener('beforeunload', this.alertBeforeRefresh);
        this.props.history.push(GO_TO_END_CALL_WITH_ID(this.props.match.params.vId), {
            docName: this.state.docName,
        });
    };

    initLocalStream = async (): Promise<void> => {
        await this.unpublishLocalStream();

        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();

            if (!this.state.isAudioOn) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                localTracks.audioTrack.setMuted(true);
            }

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack({ facingMode: 'user' });

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            localTracks.videoTrack.play(DOC_VD_ELEMENT_ID);

            if (!this.state.isVideoOn) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                localTracks.videoTrack.setMuted(true);
            }
        } catch (error) {
            this.setState({ allowPermissionDialog: true });
        }
    };

    pageReferrer = document.referrer;

    render(): ReactNode {
        const {
            docName,
            fetchState,
            isVideoOn,
            isAudioOn,
            isDocJoined,
            docDp,
            isCallInit,
            isDocAudioOff,
            isDocVideoOff,
            isDocLeft,
            scriptsLoaded,
            allowPermissionDialog,
            meetingUrlForGuest,
        } = this.state;

        if (!scriptsLoaded.agoraJs) {
            if (this.pageReferrer === 'https://consultation.metropolisindia.com/') {
                return (
                    <div className="w-full h-full">
                        <FullScreenLoader />
                    </div>
                );
            } else {
                return <SplashAnimation />;
            }
        }

        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - Teleconsultation</title>
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, maximum-scale=1"
                    />
                </Helmet>
                <div className="flex flex-col h-full font-grotesk bg-neutral-black">
                    {fetchState === 'successTeleV2' ? (
                        <iframe
                            src={meetingUrlForGuest}
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                            allow="camera; microphone; fullscreen; display-capture"
                        ></iframe>
                    ) : fetchState === 'success' ? (
                        <div className="relative flex flex-col items-center flex-auto h-full m-16 rounded-8 bg-neutral-black">
                            <div
                                style={{ width: '100%', height: '100%' }}
                                id={PT_VD_ELEMENT_ID}
                            ></div>
                            {isDocJoined && isCallInit && (
                                <Fragment>
                                    <Timer
                                        docName={docName}
                                        isAudioOff={isDocAudioOff}
                                        docDp={docDp}
                                    />
                                </Fragment>
                            )}
                            {isDocJoined && isDocVideoOff && (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        position: 'absolute',
                                    }}
                                    className="bg-neutral-1"
                                >
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <div className="flex flex-col items-center justify-center">
                                            <div
                                                className={`flex items-center justify-center w-80 h-80 rounded-full bg-neutral-7 `}
                                            >
                                                <div className="w-24 h-24 flex items-center justify-center">
                                                    <span className="capitalize"></span>
                                                    {docName
                                                        .split(' ')
                                                        .map((n) => n[0])
                                                        .join('')}
                                                </div>
                                            </div>
                                            <p className="mt-24 text-center text-neutral-9 text-14 font-700">
                                                {docName}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!isDocJoined && (
                                <div
                                    style={{ width: '100%', height: '100%', position: 'absolute' }}
                                >
                                    <div className="flex flex-col items-center justify-center p-16 space-y-16 h-full">
                                        <p className="text-white text-center">
                                            <p>
                                                {isCallInit && isDocLeft
                                                    ? 'Waiting for '
                                                    : isCallInit
                                                    ? 'Joining Call with '
                                                    : 'Start Call with '}
                                            </p>
                                            <p className="font-700 text-white">
                                                <p className="flex items-center space-x-6">
                                                    {docDp && (
                                                        <img
                                                            src={docDp}
                                                            className="w-32 h-32 rounded-full"
                                                            loading="eager"
                                                        />
                                                    )}
                                                    <p>
                                                        {docName}
                                                        {isCallInit ? '...' : ''}
                                                    </p>
                                                </p>
                                            </p>
                                        </p>
                                    </div>
                                </div>
                            )}
                            {isDocJoined && !isCallInit && (
                                <div
                                    style={{ width: '100%', height: '100%', position: 'absolute' }}
                                >
                                    <div className="flex flex-col items-center justify-center p-16 space-y-16 h-full">
                                        <p className="text-white text-center">
                                            <p>Call ended with</p>
                                            <p className="flex items-center space-x-6">
                                                {docDp && (
                                                    <img
                                                        src={docDp}
                                                        className="w-32 h-32 rounded-full"
                                                    />
                                                )}
                                                <p>{docName}</p>
                                            </p>
                                        </p>
                                    </div>
                                </div>
                            )}
                            {!isDocJoined && !isCallInit ? (
                                <div
                                    style={{ position: 'absolute', bottom: 0 }}
                                    className=" flex justify-center items-end space-x-44 p-24"
                                >
                                    <div className="flex flex-col items-center justify-center space-y-10 text-13">
                                        <p className="font-700 text-white">Start Call</p>
                                        <div
                                            onClick={this.initCall}
                                            className="flex items-center justify-center cursor-pointer w-52 h-52 rounded-full bg-status-success"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                className="w-24 h-24 fill-white"
                                            >
                                                <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ) : !isDocJoined && isCallInit ? (
                                <div
                                    style={{ position: 'absolute', bottom: 24 }}
                                    onClick={this.endCall}
                                    className="flex items-center justify-center w-40 h-40"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 640 512"
                                        className="fill-status-warning w-24 h-24"
                                    >
                                        <path d="M635.4 293.6l-52.73 84.25c-7.631 12.2-23.09 17.35-36.63 11.98l-105.4-42.1c-12.45-4.925-20.14-17.65-18.71-30.87l6.64-66.46C358.3 226.5 281.8 226.5 211.6 250.4l6.621 66.51c1.338 13.27-6.28 25.86-18.67 30.85l-105.5 42.13c-13.6 5.307-29.04 .2437-36.72-12.04l-52.71-84.22C-2.861 281.8-1.118 266.5 8.85 256.5C180.4 85.16 459.6 85.17 631.1 256.5C641.1 266.5 642.9 281.8 635.4 293.6z" />
                                    </svg>
                                </div>
                            ) : (
                                <div
                                    style={{ position: 'absolute', bottom: 0 }}
                                    className={`flex items-end ${
                                        isCallInit ? 'justify-between' : 'justify-center'
                                    } p-24 w-full`}
                                >
                                    {!isCallInit ? (
                                        <div className="flex flex-col items-center justify-center space-y-16">
                                            <p className="font-700 text-white">Restart Call</p>
                                            <div
                                                onClick={this.initCall}
                                                className="flex items-center justify-center cursor-pointer w-52 h-52 rounded-full bg-status-success"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-24 h-24 fill-white"
                                                >
                                                    <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" />
                                                </svg>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            onClick={this.endCall}
                                            className="flex items-center justify-center w-40 h-40"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 640 512"
                                                className="fill-status-warning w-24 h-24"
                                            >
                                                <path d="M635.4 293.6l-52.73 84.25c-7.631 12.2-23.09 17.35-36.63 11.98l-105.4-42.1c-12.45-4.925-20.14-17.65-18.71-30.87l6.64-66.46C358.3 226.5 281.8 226.5 211.6 250.4l6.621 66.51c1.338 13.27-6.28 25.86-18.67 30.85l-105.5 42.13c-13.6 5.307-29.04 .2437-36.72-12.04l-52.71-84.22C-2.861 281.8-1.118 266.5 8.85 256.5C180.4 85.16 459.6 85.17 631.1 256.5C641.1 266.5 642.9 281.8 635.4 293.6z" />
                                            </svg>
                                        </div>
                                    )}

                                    {isCallInit && (
                                        <div
                                            onClick={this.muteMyself}
                                            className={`flex items-center justify-center w-40 h-40 ${
                                                !isAudioOn ? 'rounded-full bg-white' : ''
                                            }`}
                                        >
                                            {isAudioOn ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 352 512"
                                                    className="fill-white"
                                                    width="24"
                                                    height="24"
                                                >
                                                    <path d="M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"></path>
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                    className="fill-neutral-1"
                                                    width="30"
                                                    height="30"
                                                >
                                                    <path d="M256 96c0-35.3 28.7-64 64-64s64 28.7 64 64v149.3l30.7 24.1c.6-4.4 1.3-8.8 1.3-13.4V96c0-53-43-96-96-96s-96 43-96 96v23.3l32 25.2zm224 160v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56c0 12.3-2.3 24-5.6 35.3l27 21.3C476.2 295 480 276 480 256zm-72 224h-72v-65c27.2-2.7 52.1-12.7 73.6-27.3l-26.4-20.8c-21 12-45.6 18.6-71.9 16.8-68-4.5-119.3-64.1-119.3-132.2v-35.2l-28.5-22.5c-2 1.5-3.5 3.5-3.5 6.1v50.3c0 83.4 61.7 156.1 144 164.4V480h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-88-128c12.6 0 24.5-2.6 35.5-7l-32.2-25.4c-1.1.1-2.1.3-3.3.3-31.3 0-57.3-22.6-62.8-52.4l-33.2-26V256c0 53 43 96 96 96zm317 133.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"></path>
                                                </svg>
                                            )}
                                        </div>
                                    )}

                                    {isCallInit && (
                                        <div
                                            onClick={this.videoOnOff}
                                            className={`flex items-center justify-center w-40 h-40 ${
                                                !isVideoOn ? 'bg-white' : 'bg-neutral-5'
                                            } rounded-full`}
                                        >
                                            {isVideoOn ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 576 512"
                                                    width="24"
                                                    height="24"
                                                    className="fill-white"
                                                >
                                                    <path d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"></path>
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                    width="30"
                                                    height="30"
                                                    className="fill-neutral-1"
                                                >
                                                    <path d="M637 485.2L142.7 96l-16.2-12.7L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8L438.9 370l9.1 7.2 169 133.1c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.6 2.2-8.6-1.2-11.4zM396.2 416H83.8c-10.7 0-19.8-7.2-19.8-15.8V135.9l-31.9-25.1c0 .4-.1.7-.1 1.1v288.4c0 26.4 23.2 47.8 51.8 47.8h312.4c16.6 0 31.2-7.3 40.7-18.5l-25.3-19.9c-3.7 3.7-9.1 6.3-15.4 6.3zm0-320c10.7 0 19.8 7.2 19.8 15.8v138.3l32 25.2v-65.8L576 128v248.1l28.4 22.4c2.1-4.2 3.6-8.8 3.6-14v-257C608 109 592.5 96 575.9 96c-6.2 0-12.5 1.8-18.2 5.7L448 171.6v-59.8c0-26.4-23.2-47.8-51.8-47.8H179.6l40.6 32h176z"></path>
                                                </svg>
                                            )}
                                        </div>
                                    )}
                                    {/* <div
                             onClick={this.changeCamera}
                             className={`flex items-center justify-center cursor-pointer w-40 h-40 ${
                                 this.state.cameraFacingMode === 'environment'
                                     ? 'rotate-180'
                                     : ''
                             } transition-all transform-gpu`}
                         >
                             <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 className="w-24 h-24 fill-white"
                             >
                                 <path d="M480 256c-17.67 0-32 14.31-32 32c0 52.94-43.06 96-96 96H192L192 344c0-9.469-5.578-18.06-14.23-21.94C169.1 318.3 159 319.8 151.9 326.2l-80 72C66.89 402.7 64 409.2 64 416s2.891 13.28 7.938 17.84l80 72C156.4 509.9 162.2 512 168 512c3.312 0 6.615-.6875 9.756-2.062C186.4 506.1 192 497.5 192 488L192 448h160c88.22 0 160-71.78 160-160C512 270.3 497.7 256 480 256zM160 128h159.1L320 168c0 9.469 5.578 18.06 14.23 21.94C337.4 191.3 340.7 192 343.1 192c5.812 0 11.57-2.125 16.07-6.156l80-72C445.1 109.3 448 102.8 448 95.1s-2.891-13.28-7.938-17.84l-80-72c-7.047-6.312-17.19-7.875-25.83-4.094C325.6 5.938 319.1 14.53 319.1 24L320 64H160C71.78 64 0 135.8 0 224c0 17.69 14.33 32 32 32s32-14.31 32-32C64 171.1 107.1 128 160 128z" />
                             </svg>
                         </div> */}
                                </div>
                            )}
                            <div
                                id={DOC_VD_ELEMENT_ID}
                                style={{
                                    minWidth: '150px',
                                    minHeight: '200px',
                                    width: '26%',
                                    height: '25%',
                                    position: 'absolute',
                                    bottom: '80px',
                                    left: '16px',
                                }}
                            ></div>
                            {!isVideoOn && (
                                <div
                                    className="flex items-center justify-center rounded-8 bg-neutral-4"
                                    style={{
                                        minWidth: '150px',
                                        minHeight: '200px',
                                        width: '26%',
                                        height: '25%',
                                        position: 'absolute',
                                        bottom: '80px',
                                        left: '16px',
                                    }}
                                >
                                    <div className="w-32 h-32 rounded-full bg-text-primary flex items-center justify-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                            className="w-24 h-24 fill-white"
                                        >
                                            <path d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z" />
                                        </svg>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : fetchState === 'error' ? (
                        <div className="flex flex-col items-center justify-center font-700 flex-auto h-full m-16 rounded-8 bg-neutral-black text-white ">
                            <p style={{ width: '80%' }} className="text-center">
                                Opps, seems like your appointment ID is invalid.
                            </p>
                        </div>
                    ) : null}
                    {allowPermissionDialog && (
                        <div
                            style={{
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                position: 'fixed',
                                width: 'calc(100% - 64px)',
                            }}
                            className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-16 rounded-8 space-y-16"
                        >
                            <div className="flex space-x-16 items-center">
                                <div className="w-16 h-16 flex items-center justify-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-16 h-16 fill-status-warning"
                                    >
                                        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z" />
                                    </svg>
                                </div>
                                <p className="font-700 text-18 text-text-primary">
                                    Allow Permissions
                                </p>
                            </div>

                            <div className="flex flex-col items-end text-text-secondary">
                                <p>
                                    Eka Care requires Camera and Microphone access to perform
                                    teleconsultation. <br />
                                    Click on
                                    <span style={{ display: 'inline-flex' }} className="mx-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                            className="w-16 h-16 fill-text-secondary"
                                        >
                                            <path d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z" />
                                        </svg>
                                    </span>
                                    icon in the URL and change the settings of your browser.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </Fragment>
        );
    }
}

const Timer: React.FC<{ docName: string; docDp: string; isAudioOff: boolean }> = ({
    docName,
    docDp,
    isAudioOff,
}) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | undefined = undefined;
        interval = setInterval(() => {
            setSeconds((seconds) => seconds + 1);
        }, 1000);

        return () => interval && clearInterval(interval);
    }, [seconds]);

    return (
        <div className="flex items-center justify-between p-16 absolute w-full">
            <p className="flex items-center space-x-6 text-white text-13 font-700">
                {docDp && <img src={docDp} className="w-32 h-32 rounded-full" />}
                <p>{docName}</p>
            </p>
            {isAudioOff && (
                <div className="flex items-center justify-center cursor-pointer w-24 h-24">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                        className="fill-white"
                        width="24"
                        height="24"
                    >
                        <path d="M256 96c0-35.3 28.7-64 64-64s64 28.7 64 64v149.3l30.7 24.1c.6-4.4 1.3-8.8 1.3-13.4V96c0-53-43-96-96-96s-96 43-96 96v23.3l32 25.2zm224 160v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56c0 12.3-2.3 24-5.6 35.3l27 21.3C476.2 295 480 276 480 256zm-72 224h-72v-65c27.2-2.7 52.1-12.7 73.6-27.3l-26.4-20.8c-21 12-45.6 18.6-71.9 16.8-68-4.5-119.3-64.1-119.3-132.2v-35.2l-28.5-22.5c-2 1.5-3.5 3.5-3.5 6.1v50.3c0 83.4 61.7 156.1 144 164.4V480h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-88-128c12.6 0 24.5-2.6 35.5-7l-32.2-25.4c-1.1.1-2.1.3-3.3.3-31.3 0-57.3-22.6-62.8-52.4l-33.2-26V256c0 53 43 96 96 96zm317 133.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"></path>
                    </svg>
                </div>
            )}
        </div>
    );
};

export default VisitVideoCall;

const SplashAnimation = () => {
    const circle = useAnimation();
    const image = useAnimation();

    useEffect(() => {
        (async function () {
            await circle.start({
                height: '320px',
                width: '320px',
                opacity: 0,
                transition: { duration: 1 },
            });
            await image.start({ height: '120px', width: '120px', transition: { duration: 1 } });
        })();
    });

    return (
        <div className="flex flex-col items-center justify-center h-full font-grotesk bg-icons-brand">
            <div className="w-256 h-256 relative flex items-center justify-center">
                <motion.div
                    initial={{ height: '0', width: '0' }}
                    animate={circle}
                    className="absolute h-0 w-0 border-2 border-white rounded-full"
                ></motion.div>
                <motion.img
                    initial={{ height: '0', width: '0' }}
                    animate={image}
                    src="/EkaSymbol.png"
                    className="top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 absolute z-10"
                />
            </div>
        </div>
    );
};
